/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { NavLink, useLocation, useSearchParams } from "react-router-dom";
import "./sidebar.scss";
import img1 from "../../assets/imgs/img1.png";
import img2 from "../../assets/imgs/img2.png";
// import { ReactComponent as CricIcon } from "../../assets/svg/cricketIcon.svg"
// import CricIcon from "../../assets/svg/cricketIcon.svg";
import { useEffect } from "react";
import { toLower } from "lodash";

const DropDownComponent = ({ title, list, status }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Check if URL contains 'thesports-' and if this is the TheSports submenu
  const shouldAutoExpand =
    location.pathname.includes("thesports-") &&
    toLower(title) === "thesports";

  const [active, setActive] = useState(shouldAutoExpand || status);

  useEffect(() => {
    // Auto-expand TheSports submenu when URL contains 'thesports-'
    if (shouldAutoExpand) {
      setActive(true);
    }
  }, [location.pathname, shouldAutoExpand]);
  const li = list.map((item, index) => {
    return (
      <li className="listitem11" key={index}>
        {/* <Link 
                    className='dropdownsub'
                     to={item?.path}>{item?.title}</Link> */}
        <NavLink className="dropdownitem " to={item?.path}>
          {item?.title}
        </NavLink>
      </li>
    );
  });

  return (
    <div className="sidebar_menu_item sub_menu_sport">
      <a>
        <div
          className={`navbar11 d-flex justify-content-between ${
            active && "activeBg11"
          }`}
          onClick={() => setActive(!active)}
        >
          <h6 className="headingdropdown mb-0"> {title}</h6>
          <p className="mb-0">
            {" "}
            {active ? (
              <img className="imgnav1" src={img2} alt="icon" />
            ) : (
              <img className="imgnav1" src={img1} alt="icon" />
            )}
          </p>
        </div>
      </a>

      <ul className="sidebar_menu_inner">{active && li}</ul>
    </div>
  );
};

const Dropdown = ({
  title,
  list,
  status,
  children,
  currentMenu,
  setCurrentMenu,
  name,
}) => {
  const loc = useLocation();
  const [active, setActive] = useState(currentMenu === name ? true : false);

  useEffect(() => {
    setActive(currentMenu === name ? true : false);
  }, [currentMenu]);

  const li = list.map((item, index) => {
    return (
      <li className="listitem11 test" key={index}>
        {item?.subNav ? (
          <DropDownComponent
            title={item?.title}
            list={item?.subNav}
            status={false}
          />
        ) : (
          <a
            className={`dropdownitem ${
              currentMenu === name &&
              loc?.pathname?.startsWith(item?.path?.split("?")?.[0])
                ? "active"
                : ""
            }`}
            href={item?.path}
          >
            {item?.title}
          </a>
        )}
      </li>
    );
  });

  return (
    <>
      <div className="sidebar_menu_item">
        <a
        // href={`/matches?sport=${name}`}
        >
          <div
            className={`navbar11 d-flex justify-content-between align-items-center ${
              active && "activeBg"
            }`}
            onClick={() => {
              setActive(!active);
            }}
          >
            <h5 className="d-flex align-items-start heading mb-0">
              {" "}
              {children} {title}
            </h5>{" "}
            {active ? (
              <img className="imgnav" src={img2} alt="icon" />
            ) : (
              <img className="imgnav" src={img1} alt="icon" />
            )}
          </div>
        </a>
        <ul className="sidebar_menu_inner">{active && li}</ul>
      </div>
      {/* {list?.subNav && (
        <DropDownComponent
          title={title}
          list={list?.subNav}
          status={false}
        />
      )} */}
    </>
  );
};
export default Dropdown;
